module.exports = __webpack_public_path__ + "static/media/team-bg-2-bk.5ed35a47.jpg";